import React from 'react';
import { IconProps } from '.';

const SvgSortAsc = ({
  size = 16,
  color = '#292B2B',
  secondaryColor = '#B3BABD',
  className,
  ...props
}: IconProps): JSX.Element => {
  return (
    <svg
      width={size}
      height={size}
      fill='none'
      viewBox='0 0 24 24'
      className={className ? 'pds-icon ' + className : 'pds-icon'}
      {...props}
    >
      <path
        fill={color}
        d='M7.617 7.617V19.25h-1.5V7.504L3.811 9.811 2.75 8.75l4.06-4.06 4.061 4.06-1.06 1.06-2.194-2.193ZM12.25 16.75h9v1.5h-9v-1.5ZM12.25 13.25h7.5v1.5h-7.5v-1.5ZM18.25 9.75h-6v1.5h6v-1.5ZM12.25 6.25h4v1.5h-4v-1.5Z'
      />
    </svg>
  );
};

export default SvgSortAsc;
